import { normalizeTrack } from './trackModel';

export function mergeTrackMix(track, patch = {}) {
  const candidate = {
    ...track,
    ...(Object.prototype.hasOwnProperty.call(patch, 'volume') ? { volume: patch.volume } : {}),
    ...(Object.prototype.hasOwnProperty.call(patch, 'pan') ? { pan: patch.pan } : {}),
    ...(patch.effects ? { effects: { ...track.effects, ...patch.effects, eq: { ...track.effects?.eq, ...patch.effects.eq } } } : {}),
  };
  return normalizeTrack(candidate);
}

export function commitTrackMixState(pushState, arrangement, trackId, patch) {
  let changed = false;
  const tracks = arrangement.tracks.map((track) => {
    if (track.id !== trackId) return track;
    const next = mergeTrackMix(track, patch);
    const before = JSON.stringify({ volume: track.volume, pan: track.pan, effects: track.effects });
    const after = JSON.stringify({ volume: next.volume, pan: next.pan, effects: next.effects });
    if (before === after) return track;
    changed = true;
    return next;
  });
  if (changed) pushState({ tracks, sectionMarkers: arrangement.sectionMarkers });
  return { changed, tracks };
}
